"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _styles = _interopRequireDefault(require("./styles"));

var _core = require("@emotion/core");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  list-style: none;\n  top: 8px;\n  padding: 0;\n  border: none;\n  margin: 0;\n  position: absolute;\n  width: 100%;\n\n  &:focus {\n    outline: 0;\n  }\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  transition: all 300ms;\n  z-index: 100;\n  width: 100%;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  min-height: 48px;\n  font-size: 16px;\n  padding: 15px;\n  text-align: center;\n  box-sizing: border-box;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var NothingFound = (0, _theme.styled)('div')(_templateObject());
var DropdownContainer = (0, _theme.styled)('div')(_templateObject2(), _styles.default.dropdown.container);
var OptionsContainer = (0, _theme.styled)('ul')(_templateObject3(), _styles.default.dropdown.optionsContainer);

var Dropdown = function Dropdown(_ref) {
  var alignRight = _ref.alignRight,
      children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      innerRef = _ref.innerRef,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$noResult = _ref.noResult,
      noResult = _ref$noResult === void 0 ? 'Nothing Found' : _ref$noResult,
      uia = _ref.uia;
  var hasChildren = children && _react.default.Children.count(children) > 0;
  return (0, _core.jsx)(DropdownContainer, {
    alignRight: alignRight,
    "data-uia-dropdown": uia,
    isOpen: isOpen
  }, isOpen && (0, _core.jsx)(OptionsContainer, {
    className: className,
    id: "".concat(id, "_owned_listbox"),
    ref: innerRef,
    role: "listbox",
    tabIndex: -1
  }, hasChildren ? children : (0, _core.jsx)(NothingFound, null, noResult)));
};

var _default = Dropdown;
exports.default = _default;